export default __webpack_public_path__ + "static/media/Dr Vandyke Lomotey.d3367c49.pdf";